import React, { useContext, useEffect, useRef, useState } from "react";
import { motion, useAnimation } from "framer-motion";
import InfinityCard from "../InfinityCard";
import SpriteAnimator from "./SpriteAnimator";
import { MainContext } from "../../App";
import AudioManager from "../../@shared/utils/AudioManager";

const SlapCardAnimation = ({ card, onFinish }) => {
  const { deviceType } = useContext(MainContext);
  const cardControls = useAnimation();
  const flashControls = useAnimation();
  const [showSmoke, setShowSmoke] = useState(false);
  const [soundReady, setSoundReady] = useState(false);
  const soundRef = useRef(null);

  // Load the sound using the Audio API
  useEffect(() => {
    const sound = new Audio(
      require("../../@shared/assets/sounds/sfx-cards-woosh.mp3")
    );
    soundRef.current = sound;
    sound.oncanplaythrough = () => {
      setSoundReady(true);
      console.log("🎧 Sound loaded!");
    };
    return () => {
      soundRef.current && soundRef.current.pause();
      soundRef.current = null;
    };
  }, []);

  // Run the animation sequence when the card is provided.
  useEffect(() => {
    if (!card) return;
    runAnimation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [card]);

  const runAnimation = () => {
    // Start the entry animation concurrently:
    cardControls.start({
      scale: [0.5, 1.5, 1.2, 1.3],
      rotate: [-60, 0],
      y: [-600, 0, -15, 0],
      transition: {
        scale: { duration: 0.71, ease: "easeInOut" },
        rotate: { duration: 0.4, ease: "easeInOut" },
        y: {
          duration: 0.72,
          ease: "easeInOut",
          // Define keyframe times to approximate the native delays:
          times: [0, 0.5 / 0.72, (0.5 + 0.12) / 0.72, 1],
        },
      },
    });

    // After 600ms: trigger flash overlay and shake effect
    setTimeout(() => {
      flashControls.start({
        opacity: [0, 0.8, 0],
        transition: { duration: 0.23, ease: "linear" },
      });
      cardControls.start({
        x: [0, 10, -10, 6, -6, 0],
        transition: { duration: 0.25, ease: "easeInOut" },
      });
      // Play the slap sound if it's loaded
      if (soundReady && soundRef.current) {
        soundRef.current.currentTime = 0;
        soundRef.current.play();
        console.log("🔊 Playing slap sound...");
      } else {
        console.warn("⚠️ Sound not loaded yet!");
      }
    }, 600);

    // After 700ms: show the smoke effect
    setTimeout(() => {
      setShowSmoke(true);
      AudioManager.playSFX("cardSlapPackOpen");
      // If your SpriteAnimator has a start method via ref, you could trigger it here.
    }, 700);

    // After 1100ms: add a slight post-impact spin.
    setTimeout(() => {
      cardControls.start({
        rotate: 10,
        transition: { duration: 0.3, ease: "easeInOut" },
      });
    }, 700);

    // After 2500ms: fade out the entire card and then trigger onFinish.
    setTimeout(() => {
      cardControls.start({
        opacity: 0,
        transition: { duration: 0.35, ease: "easeInOut" },
      });
      setTimeout(() => {
        if (onFinish) onFinish();
      }, 350);
    }, 1500);
  };

  if (!card) return null;

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 6000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* Flash Overlay */}
      <motion.div
        animate={flashControls}
        initial={{ opacity: 0 }}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "#fff",
          zIndex: 10000,
        }}
      />
      {/* Smoke Puff */}
      {/* {showSmoke && (
                <SpriteAnimator
                    animationName="smokepuff1"
                    frameWidth={64}
                    frameHeight={64}
                    frameCount={12}
                    fps={20}
                    loop={false}
                    style={{
                        position: "absolute",
                        bottom: "-35%",
                        width: "400px",
                        height: "400px",
                        alignSelf: "center",
                        transform: "scale(4)",
                    }}
                />
            )} */}
      {/* Animated Card */}
      <motion.div
        animate={cardControls}
        initial={{ scale: 0.5, rotate: -60, y: -600, x: 0, opacity: 1 }}
        style={{
          boxShadow: "6px 6px 10px rgba(0,0,0,0.3)",
          //   height: deviceType === "mobile" ? "30%" : "50%",
          height:
            window.innerWidth > 900
              ? window.innerHeight * 0.38
              : window.innerHeight * 0.3,

          borderRadius: "12px",
        }}
      >
        <InfinityCard
          {...card}
          heightPer={100}
          borderPx={8}
          containerHeight={
            window.innerWidth > 900
              ? window.innerHeight * 0.38
              : window.innerHeight * 0.3
          }
        />
      </motion.div>
    </div>
  );
};

export default SlapCardAnimation;
